// extracted by mini-css-extract-plugin
module.exports = {"suggestionMediaOrders":"styles_suggestionMediaOrders__2YVC5","title":"styles_title__2o0qF"};